import "./carousel.css";

import React from "react";
import Offcanvas from "react-bootstrap/Offcanvas";

import CollectionMobileList from "@/components/ui/collection/mobile-list";
import CollectionCarousel from "@/components/ui/collection/web-carousel";
import useCollection from "@/hooks/useCollection";
import useMe from "@/hooks/useMe";
import useSnackbar from "@/hooks/useSnackbar";

import AddCollectionModal from "./add-collection-modal";

interface CollectionDrawerProps {}

const CollectionDrawer: React.FC<CollectionDrawerProps> = () => {
  const { showDrawer, setShowDrawer, saveItem } = useCollection();
  const closeDrawer = () => {
    setShowDrawer(false);
  };
  const { showSnackbar } = useSnackbar();
  const { fetchMe } = useMe();

  const handleSave = async (collection: any) => {
    saveItem({
      collection,
      onSuccess: () => {
        showSnackbar(`Item added to "${collection.name}"`);
        setShowDrawer(false);
        fetchMe();
      },
    });
  };

  const onCreateCollectionSuccess = (collection: any) => {
    handleSave(collection);
  };

  return (
    <>
      <div className="collections-drawer">
        <Offcanvas
          show={showDrawer}
          placement="bottom"
          style={{ height: "auto", display: `var(--web-drawer)` }}
          onHide={closeDrawer}
        >
          <div className="drawer-content section-container">
            <img
              className="close-icon"
              src="/close-black.svg"
              onClick={closeDrawer}
            />
            <div className="drawer-header">
              <div className="drawer-title">Add to collection</div>
              <AddCollectionModal onSuccess={onCreateCollectionSuccess}>
                <div className="drawer-subtitle">Create new collection</div>
              </AddCollectionModal>
            </div>
            <div className="">
              <CollectionCarousel />
            </div>
          </div>
        </Offcanvas>
        <Offcanvas
          show={showDrawer}
          placement="top"
          style={{
            height: "100%",
            display: `var(--mobile-drawer)`,
            overflow: "auto",
            zIndex: 9999,
          }}
          onHide={closeDrawer}
        >
          <div className="drawer-content section-container">
            <img
              className="close-icon"
              src="/close-black.svg"
              onClick={closeDrawer}
            />
            <div className="drawer-header">
              <div className="drawer-title">Add to collection</div>
              <AddCollectionModal onSuccess={onCreateCollectionSuccess}>
                <div className="drawer-subtitle">Create new collection</div>
              </AddCollectionModal>
            </div>
            <div className="">
              <CollectionMobileList />
            </div>
          </div>
        </Offcanvas>
      </div>
      <style jsx>{`
        .drawer-content {
          padding: 0 72px 64px;
          margin: auto;
          position: relative;

          .close-icon {
            position: absolute;
            top: 24px;
            right: 24px;
            cursor: pointer;
          }

          .drawer-header {
            padding: 24px 0;

            .drawer-title {
              color: #191919;
              font-size: 24px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
            }

            .drawer-subtitle {
              color: #191919;
              font-size: 16px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
              text-decoration-line: underline;
              cursor: pointer;
              margin-top: 8px;
            }
          }
        }

        @media (max-width: 768px) {
          .drawer-content {
            padding: 0 24px;
            margin: 0;

            .close-icon {
              position: absolute;
              top: 24px;
              right: 24px;
              cursor: pointer;
            }

            .drawer-header {
              padding: 24px 0;

              .drawer-subtitle {
                font-size: 14px;
                margin-top: 4px;
              }
            }
          }
        }
      `}</style>
    </>
  );
};

export default CollectionDrawer;
